(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  if (!window.njCartCouponBound) {
    const applyCartCoupon = (coupon) => {
      const input = coupon.querySelector('input');
      const code = input?.value.trim();
      if (!code) {
        input?.focus();
        return;
      }
      const cartUrl = coupon.dataset.cartUrl || '/cart';
      window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartUrl)}`);
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cart-coupon-apply]');
      if (button) applyCartCoupon(button.closest('[data-cart-coupon]'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches('[data-cart-coupon] input')) {
        event.preventDefault();
        applyCartCoupon(event.target.closest('[data-cart-coupon]'));
      }
    });

    window.njCartCouponBound = true;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-about-craft"] && !Shopify.designMode) return;
  try {
    

(() => {

  const selector =
    '[data-nj-about-craft]';


  const initSection = (section) => {

    if (
      !section ||
      section.dataset.njAboutInitialized === 'true'
    ) return;


    section.dataset.njAboutInitialized =
      'true';


    if (
      !section.classList.contains(
        'nj-about-craft--animate'
      )
    ) {

      section.classList.add(
        'is-visible'
      );

      return;

    }


    if (
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches ||

      !(
        'IntersectionObserver'
        in window
      )
    ) {

      section.classList.add(
        'is-visible'
      );

      return;

    }


    const observer =
      new IntersectionObserver(

        (entries) => {

          entries.forEach(
            (entry) => {

              if (
                entry.isIntersecting
              ) {

                entry.target.classList.add(
                  'is-visible'
                );

                observer.unobserve(
                  entry.target
                );

              }

            }
          );

        },

        {
          threshold: 0.18
        }

      );


    observer.observe(
      section
    );

  };


  document
    .querySelectorAll(selector)
    .forEach(initSection);


  document.addEventListener(
    'shopify:section:load',

    (event) => {

      const section =
        event.target.querySelector(
          selector
        );


      if (section) {

        initSection(
          section
        );

      }

    }

  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-about-stats"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const reduceMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    function countNumber(el, duration) {

      if (
        !el ||
        el.dataset.counted === 'true'
      ) return;


      const raw =
        el.dataset.value ||
        el.textContent.trim();


      const match =
        raw.match(/-?[\d,.]+/);


      if (!match) {

        el.dataset.counted = 'true';

        return;

      }


      const numericText =
        match[0].replace(/,/g, '');


      const target =
        Number.parseFloat(numericText);


      if (Number.isNaN(target)) {

        el.dataset.counted = 'true';

        return;

      }


      const prefix =
        raw.slice(
          0,
          match.index
        );


      const suffix =
        raw.slice(
          (match.index || 0)
          +
          match[0].length
        );


      const decimals =
        numericText.includes('.')
          ?
          numericText
            .split('.')[1]
            .length
          :
          0;


      const useGrouping =
        match[0].includes(',');


      const formatValue = (value) => {

        return new Intl.NumberFormat(
          undefined,
          {
            minimumFractionDigits:
              decimals,

            maximumFractionDigits:
              decimals,

            useGrouping
          }
        ).format(value);

      };


      if (reduceMotion) {

        el.textContent = raw;

        el.dataset.counted =
          'true';

        return;

      }


      el.dataset.counted =
        'true';


      const startTime =
        performance.now();


      function update(now) {

        const progress =
          Math.min(
            (now - startTime)
            /
            duration,
            1
          );


        const eased =
          1
          -
          Math.pow(
            1 - progress,
            3
          );


        const current =
          target * eased;


        el.textContent =
          `${prefix}${formatValue(current)}${suffix}`;


        if (progress < 1) {

          requestAnimationFrame(
            update
          );

        } else {

          el.textContent =
            raw;

        }

      }


      requestAnimationFrame(
        update
      );

    }


    function revealSection(section) {

      if (
        !section ||
        section.classList.contains(
          'is-visible'
        )
      ) return;


      section.classList.add(
        'is-visible'
      );


      if (
        section.dataset.countUp
        ===
        'true'
      ) {

        const duration =
          Number.parseInt(
            section.dataset.countDuration,
            10
          )
          ||
          1200;


        section
          .querySelectorAll(
            '.nj-about-stats__number[data-count-up="true"]'
          )
          .forEach((el) => {

            countNumber(
              el,
              duration
            );

          });

      }

    }


    function initSection(section) {

      if (
        !section ||
        section.dataset.njStatsInitialized
        ===
        'true'
      ) return;


      section.dataset.njStatsInitialized =
        'true';


      const shouldAnimate =
        section.dataset.animate
        ===
        'true';


      const shouldCount =
        section.dataset.countUp
        ===
        'true';


      if (
        !shouldAnimate
        &&
        !shouldCount
      ) {

        section.classList.add(
          'is-visible'
        );

        return;

      }


      if (
        reduceMotion
        ||
        !(
          'IntersectionObserver'
          in
          window
        )
      ) {

        revealSection(
          section
        );

        return;

      }


      let fallbackTimer;


      const observer =
        new IntersectionObserver(

          (entries) => {

            entries.forEach(
              (entry) => {

                if (
                  entry.isIntersecting
                ) {

                  if (fallbackTimer) {

                    window.clearTimeout(
                      fallbackTimer
                    );

                  }


                  revealSection(
                    section
                  );


                  observer.unobserve(
                    section
                  );

                }

              }
            );

          },

          {
            threshold: 0.12,

            rootMargin:
              '0px 0px -5% 0px'
          }

        );


      observer.observe(
        section
      );


      requestAnimationFrame(
        () => {

          section.classList.add(
            'is-animation-ready'
          );


          const rect =
            section.getBoundingClientRect();


          const isAlreadyVisible =
            rect.top
            <
            window.innerHeight
            &&
            rect.bottom
            >
            0;


          if (isAlreadyVisible) {

            requestAnimationFrame(
              () =>
                revealSection(
                  section
                )
            );

          }

        }
      );


      fallbackTimer =
        window.setTimeout(
          () => {

            revealSection(
              section
            );


            observer.disconnect();

          },
          2500
        );

    }


    function initAll(
      root = document
    ) {

      root
        .querySelectorAll(
          '.nj-about-stats'
        )
        .forEach(
          initSection
        );

    }


    if (
      document.readyState
      ===
      'loading'
    ) {

      document.addEventListener(
        'DOMContentLoaded',
        () =>
          initAll()
      );

    } else {

      initAll();

    }


    document.addEventListener(
      'shopify:section:load',
      (event) => {

        initAll(
          event.target
        );

      }
    );

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-blog-index"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-nj-blog-sort]')) return;
    var section = event.target.closest('[data-nj-blog-index]');
    if (!section) return;
    var grid = section.querySelector('[data-nj-blog-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-nj-blog-card]'));
    var value = event.target.value;
    cards.sort(function(a, b) {
      if (value === 'oldest') return Number(a.dataset.date) - Number(b.dataset.date);
      if (value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
      return Number(b.dataset.date) - Number(a.dataset.date);
    });
    cards.forEach(function(card) {
      grid.appendChild(card);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-collection-page"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const initialiseCollection = (root) => {

      if (!root || root.dataset.njInitialised === 'true') {
        return;
      }

      root.dataset.njInitialised = 'true';


      /* =========================
         SORT
      ========================= */

      root.querySelectorAll('[data-nj-sort]').forEach((select) => {

        select.addEventListener('change', () => {

          if (select.form) {
            select.form.submit();
          }

        });

      });


      /* =========================
         DESKTOP GRID / LIST VIEW
      ========================= */

      const main = root.querySelector('.nj-collection-main');

      const rememberView =
        root.dataset.njRememberView === 'true';

      const storageKey =
        `nj-collection-view-${root.dataset.njSectionId}`;


      const isMobile = () =>
        window.matchMedia('(max-width: 749px)').matches;


      const applyView = (view) => {

        if (!main) {
          return;
        }

        /*
          Mobile is permanently grid.
          Desktop/tablet can use grid/list.
        */

        if (isMobile()) {

          main.classList.remove('is-list');

          root
            .querySelectorAll('[data-nj-view]')
            .forEach((button) => {

              button.classList.toggle(
                'is-active',
                button.dataset.njView === 'grid'
              );

            });

          return;
        }


        const isList = view === 'list';

        main.classList.toggle('is-list', isList);


        root
          .querySelectorAll('[data-nj-view]')
          .forEach((button) => {

            button.classList.toggle(
              'is-active',
              button.dataset.njView === view
            );

          });

      };


      if (isMobile()) {

        applyView('grid');

      } else if (rememberView) {

        try {

          const savedView =
            window.localStorage.getItem(storageKey);

          if (
            savedView === 'grid' ||
            savedView === 'list'
          ) {
            applyView(savedView);
          }

        } catch (error) {}

      }


      root
        .querySelectorAll('[data-nj-view]')
        .forEach((button) => {

          button.addEventListener('click', () => {

            if (isMobile()) {
              applyView('grid');
              return;
            }

            const view = button.dataset.njView;

            applyView(view);


            if (rememberView) {

              try {

                window.localStorage.setItem(
                  storageKey,
                  view
                );

              } catch (error) {}

            }

          });

        });


      /*
        If visitor resizes desktop -> mobile,
        force mobile back to 2-column grid.
      */

      const mobileViewQuery =
        window.matchMedia('(max-width: 749px)');


      const handleMobileViewChange = (event) => {

        if (event.matches) {

          applyView('grid');

        } else if (rememberView) {

          try {

            const savedView =
              window.localStorage.getItem(storageKey);

            if (
              savedView === 'grid' ||
              savedView === 'list'
            ) {
              applyView(savedView);
              return;
            }

          } catch (error) {}

          applyView(
            root.dataset.njDefaultView || 'grid'
          );

        } else {

          applyView(
            root.dataset.njDefaultView || 'grid'
          );

        }

      };


      if (
        typeof mobileViewQuery.addEventListener === 'function'
      ) {

        mobileViewQuery.addEventListener(
          'change',
          handleMobileViewChange
        );

      }


      /* =========================
         MOBILE FILTER / SORT
      ========================= */

      const filterToggle =
        root.querySelector('[data-nj-filter-toggle]');

      const filters =
        root.querySelector('[data-nj-filters]');

      const sortToggle =
        root.querySelector('[data-nj-mobile-sort-toggle]');

      const sortPanel =
        root.querySelector('[data-nj-mobile-sort-panel]');


      const closeFilters = () => {

        if (!filters || !filterToggle) {
          return;
        }

        filters.classList.remove('is-mobile-open');

        filterToggle.setAttribute(
          'aria-expanded',
          'false'
        );

      };


      const closeSort = () => {

        if (!sortPanel || !sortToggle) {
          return;
        }

        sortPanel.classList.remove('is-mobile-open');

        sortToggle.setAttribute(
          'aria-expanded',
          'false'
        );

      };


      if (filterToggle && filters) {

        filterToggle.addEventListener('click', () => {

          const shouldOpen =
            !filters.classList.contains(
              'is-mobile-open'
            );

          closeSort();

          filters.classList.toggle(
            'is-mobile-open',
            shouldOpen
          );

          filterToggle.setAttribute(
            'aria-expanded',
            String(shouldOpen)
          );

        });

      }


      if (sortToggle && sortPanel) {

        sortToggle.addEventListener('click', () => {

          const shouldOpen =
            !sortPanel.classList.contains(
              'is-mobile-open'
            );

          closeFilters();

          sortPanel.classList.toggle(
            'is-mobile-open',
            shouldOpen
          );

          sortToggle.setAttribute(
            'aria-expanded',
            String(shouldOpen)
          );

        });

      }


      /* =========================
         QUICK ADD / CART DRAWER
      ========================= */

      root.addEventListener('submit', async (event) => {

        const form =
          event.target.closest(
            'form.nj-collection-card__product-form'
          );

        if (!form) {
          return;
        }


        const cartDrawer =
          document.querySelector('cart-drawer');


        if (!cartDrawer) {
          return;
        }


        event.preventDefault();


        if (form.dataset.submitting === 'true') {
          return;
        }

        form.dataset.submitting = 'true';


        const submitButton =
          form.querySelector('[type="submit"]');

        const existingError =
          form.querySelector(
            '.nj-collection-card__add-error'
          );


        if (existingError) {
          existingError.remove();
        }


        if (submitButton) {

          submitButton.disabled = true;

          submitButton.setAttribute(
            'aria-busy',
            'true'
          );

        }


        try {

          const formData =
            new FormData(form);


          let sectionHandles = [
            'cart-drawer',
            'cart-icon-bubble'
          ];


          if (
            typeof cartDrawer.getSectionsToRender ===
            'function'
          ) {

            sectionHandles =
              cartDrawer
                .getSectionsToRender()
                .map(
                  (section) =>
                    section.section || section.id
                )
                .filter(Boolean);

          }


          sectionHandles =
            [...new Set(sectionHandles)];


          formData.set(
            'sections',
            sectionHandles.join(',')
          );

          formData.set(
            'sections_url',
            window.location.pathname
          );


          const rootUrl =
            window.Shopify?.routes?.root || '/';


          const response =
            await fetch(
              `${rootUrl}cart/add.js`,
              {
                method: 'POST',

                headers: {
                  Accept: 'application/json',
                  'X-Requested-With':
                    'XMLHttpRequest'
                },

                body: formData,
                credentials: 'same-origin'
              }
            );


          const result =
            await response.json();


          if (!response.ok || result.status) {

            throw new Error(
              result.description ||
              result.message ||
              'Unable to add this product to the cart.'
            );

          }


          if (
            typeof cartDrawer.renderContents ===
            'function'
          ) {

            cartDrawer.renderContents(result);

          } else if (result.sections) {

            const parser =
              new DOMParser();


            const drawerHtml =
              result.sections['cart-drawer'];

            const bubbleHtml =
              result.sections['cart-icon-bubble'];


            if (drawerHtml) {

              const drawerDocument =
                parser.parseFromString(
                  drawerHtml,
                  'text/html'
                );


              const incomingDrawer =
                drawerDocument.querySelector(
                  '#CartDrawer .drawer__inner'
                );


              const currentDrawer =
                cartDrawer.querySelector(
                  '#CartDrawer .drawer__inner'
                );


              if (
                incomingDrawer &&
                currentDrawer
              ) {

                currentDrawer.innerHTML =
                  incomingDrawer.innerHTML;

              }

            }


            if (bubbleHtml) {

              const bubbleDocument =
                parser.parseFromString(
                  bubbleHtml,
                  'text/html'
                );


              const incomingBubble =
                bubbleDocument.querySelector(
                  '#cart-icon-bubble'
                );


              const currentBubble =
                document.querySelector(
                  '#cart-icon-bubble'
                );


              if (
                incomingBubble &&
                currentBubble
              ) {

                currentBubble.innerHTML =
                  incomingBubble.innerHTML;

              }

            }

          }


          cartDrawer.classList.remove(
            'is-empty'
          );


          window.requestAnimationFrame(() => {

            if (
              typeof cartDrawer.open ===
              'function'
            ) {

              cartDrawer.open();

            } else if (
              window.Shopify?.actions?.openCart
            ) {

              window.Shopify.actions.openCart();

            } else {

              window.location.assign(
                `${rootUrl}cart`
              );

            }

          });


        } catch (error) {

          console.error(
            'Collection add-to-cart error:',
            error
          );


          const errorMessage =
            document.createElement('small');


          errorMessage.className =
            'nj-collection-card__add-error';


          errorMessage.setAttribute(
            'role',
            'alert'
          );


          errorMessage.textContent =
            error?.message ||
            'Unable to add this product to the cart.';


          form.appendChild(errorMessage);


        } finally {

          form.dataset.submitting = 'false';


          if (submitButton) {

            submitButton.disabled = false;

            submitButton.removeAttribute(
              'aria-busy'
            );

          }

        }

      });

    };


    document
      .querySelectorAll('[data-nj-section-id]')
      .forEach(initialiseCollection);


    document.addEventListener(
      'shopify:section:load',
      (event) => {

        const root =
          event.target.querySelector(
            '[data-nj-section-id]'
          );


        if (root) {
          initialiseCollection(root);
        }

      }
    );

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function setCategoryState(button, expanded) {
      var targetId = button.getAttribute('aria-controls');
      var panel = targetId ? document.getElementById(targetId) : null;

      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (panel) panel.hidden = !expanded;
    }

    document.addEventListener('click', function(event) {
      var button = event.target.closest('.nj-faq-accordion__category');
      if (!button) return;

      var section = button.closest('[data-nj-faq-accordion]');
      if (!section) return;

      var shouldOpen = button.getAttribute('aria-expanded') !== 'true';

      if (shouldOpen && section.dataset.closeGroups === 'true') {
        section.querySelectorAll('.nj-faq-accordion__category[aria-expanded="true"]').forEach(function(openButton) {
          if (openButton !== button) setCategoryState(openButton, false);
        });
      }

      setCategoryState(button, shouldOpen);
    });

    document.addEventListener('toggle', function(event) {
      var item = event.target;
      if (!item.matches('.nj-faq-accordion__item')) return;
      if (!item.open) return;

      var section = item.closest('[data-nj-faq-accordion]');
      if (!section || section.dataset.closeOthers !== 'true') return;

      section.querySelectorAll('.nj-faq-accordion__item[open]').forEach(function(openItem) {
        if (openItem !== item) openItem.open = false;
      });
    }, true);

    document.addEventListener('shopify:block:select', function(event) {
      var selectedBlock = event.target;
      var group = selectedBlock.closest('[data-faq-group]');
      if (!group) return;

      var button = group.querySelector('.nj-faq-accordion__category');
      if (button) setCategoryState(button, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async function(event) {
    var form = event.target.closest('form.nj-products__product-form');

    if (!form) return;

    event.preventDefault();

    if (form.dataset.submitting === 'true') return;

    var submitButton = form.querySelector('[type="submit"]');
    var cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) {
      form.submit();
      return;
    }

    form.dataset.submitting = 'true';

    var previousError = form.querySelector('.nj-products__quick-error');
    if (previousError) previousError.remove();

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }

    try {
      var formData = new FormData(form);
      var sectionHandles = ['cart-drawer', 'cart-icon-bubble'];

      if (typeof cartDrawer.getSectionsToRender === 'function') {
        sectionHandles = cartDrawer
          .getSectionsToRender()
          .map(function(section) {
            return section.section || section.id;
          })
          .filter(Boolean);
      }

      sectionHandles = Array.from(new Set(sectionHandles));

      formData.set('sections', sectionHandles.join(','));
      formData.set('sections_url', window.location.pathname);

      var rootUrl = window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

      var response = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData,
        credentials: 'same-origin'
      });

      var result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add this product to the cart.');
      }

      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(result);
      } else if (result.sections) {
        var parser = new DOMParser();
        var drawerHtml = result.sections['cart-drawer'];
        var bubbleHtml = result.sections['cart-icon-bubble'];

        if (drawerHtml) {
          var drawerDocument = parser.parseFromString(drawerHtml, 'text/html');
          var incomingDrawer = drawerDocument.querySelector('#CartDrawer .drawer__inner');
          var currentDrawer = cartDrawer.querySelector('#CartDrawer .drawer__inner');

          if (incomingDrawer && currentDrawer) {
            currentDrawer.innerHTML = incomingDrawer.innerHTML;
          }
        }

        if (bubbleHtml) {
          var bubbleDocument = parser.parseFromString(bubbleHtml, 'text/html');
          var incomingBubble = bubbleDocument.querySelector('#cart-icon-bubble');
          var currentBubble = document.querySelector('#cart-icon-bubble');

          if (incomingBubble && currentBubble) {
            currentBubble.innerHTML = incomingBubble.innerHTML;
          }
        }
      }

      cartDrawer.classList.remove('is-empty');

      window.requestAnimationFrame(function() {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else if (window.Shopify && window.Shopify.actions && window.Shopify.actions.openCart) {
          window.Shopify.actions.openCart();
        }
      });
    } catch (error) {
      console.error('Featured products add-to-cart error:', error);

      var message = error && error.message
        ? error.message
        : 'Unable to add this product to the cart.';

      var existingError = form.querySelector('.nj-products__quick-error');

      if (!existingError) {
        existingError = document.createElement('small');
        existingError.className = 'nj-products__quick-error';
        existingError.setAttribute('role', 'alert');
        form.appendChild(existingError);
      }

      existingError.textContent = message;
    } finally {
      form.dataset.submitting = 'false';

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-product-main"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('click', function(event) {

  var thumb = event.target.closest('[data-nj-product-thumb]');



  if (thumb) {

    var gallerySection = thumb.closest('[data-nj-product-main]');

    var image = gallerySection && gallerySection.querySelector('.nj-product-main__featured img');



    if (image && thumb.dataset.full) {

      image.removeAttribute('srcset');

      image.src = thumb.dataset.full;

      image.alt = thumb.dataset.alt || image.alt;

    }



    var thumbs = gallerySection

      ? gallerySection.querySelectorAll('[data-nj-product-thumb]')

      : [];



    thumbs.forEach(function(item) {

      item.classList.remove('is-active');

    });



    thumb.classList.add('is-active');

    return;

  }



  var stickyAdd = event.target.closest('[data-nj-sticky-add]');



  if (stickyAdd) {

    var stickySection = stickyAdd.closest('[data-nj-product-main]');

    var mainAdd = stickySection && stickySection.querySelector('[data-nj-main-add]');

    var form = mainAdd && mainAdd.closest('form');



    if (form && mainAdd) {

      if (typeof form.requestSubmit === 'function') {

        form.requestSubmit(mainAdd);

      } else {

        mainAdd.click();

      }

    }

    return;

  }



  var qtyButton = event.target.closest('[data-nj-quantity]');



  if (!qtyButton) return;



  var wrapper = qtyButton.closest('.nj-product-main__quantity');

  var quantityInput = wrapper && wrapper.querySelector('input');



  if (!quantityInput) return;



  var quantity = parseInt(quantityInput.value || '1', 10);



  if (qtyButton.dataset.njQuantity === 'minus') {

    quantityInput.value = Math.max(1, quantity - 1);

  } else {

    quantityInput.value = quantity + 1;

  }



  quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

});



document.addEventListener('change', function(event) {

  var select = event.target.closest('[data-nj-variant-select]');



  if (!select) return;



  var section = select.closest('[data-nj-product-main]');

  var option = select.options[select.selectedIndex];



  if (!section || !option || !option.value) return;



  var price = option.dataset.price || '';

  var comparePrice = option.dataset.comparePrice || '';

  var discount = parseInt(option.dataset.discount || '0', 10);

  var available = option.dataset.available === 'true';

  var offLabel = section.dataset.njOffLabel || 'off';



  section.querySelectorAll('[data-nj-price], [data-nj-sticky-price]').forEach(function(node) {

    node.innerHTML = price;

  });



  section.querySelectorAll('[data-nj-compare-price], [data-nj-sticky-compare-price]').forEach(function(node) {

    node.innerHTML = comparePrice;

    node.hidden = !comparePrice;

  });



  section.querySelectorAll('[data-nj-discount]').forEach(function(node) {

    node.textContent = discount > 0 ? discount + '% ' + offLabel : '';

    node.hidden = discount <= 0;

  });



  var mainAdd = section.querySelector('[data-nj-main-add]');

  var stickyAdd = section.querySelector('[data-nj-sticky-add]');

  var dynamicCheckout = section.querySelector('[data-nj-dynamic-checkout]');

  var restockAlert = section.querySelector('[data-nj-restock-alert]');



  if (dynamicCheckout) {

    dynamicCheckout.hidden = !available;

  }



  [mainAdd, stickyAdd].forEach(function(button) {

    if (!button) return;



    button.disabled = !available;

    button.textContent = available

      ? section.dataset.njAddLabel

      : section.dataset.njSoldOutLabel;

  });



  if (restockAlert) {

    restockAlert.hidden = available;

    var staleConsent = restockAlert.querySelector('[data-nj-restock-marketing-consent]');
    if (staleConsent) staleConsent.hidden = true;

  }



  if (window.history && window.history.replaceState) {

    var url = new URL(window.location.href);

    url.searchParams.set('variant', option.value);

    window.history.replaceState({}, '', url.toString());

  }

});



document.querySelectorAll('[data-nj-product-main]').forEach(function(section) {

  var restockAlert = section.querySelector('[data-nj-restock-alert]');

  var variantSelect = section.querySelector('[data-nj-variant-select]');



  if (variantSelect && variantSelect.value) {

    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

  }



  if (restockAlert) {

    var restockContact = restockAlert.querySelector('[data-nj-restock-contact]');

    var restockCountry = restockAlert.querySelector('[data-nj-restock-country]');

    var restockPhoneRow = restockAlert.querySelector('[data-nj-restock-phone-row]');

    var restockContactLabel = restockAlert.querySelector('.nj-restock-alert__contact-label');

    var restockSubmit = restockAlert.querySelector('[data-nj-restock-submit]');

    var restockStatus = restockAlert.querySelector('[data-nj-restock-status]');    var marketingConsent = restockAlert.querySelector('[data-nj-restock-marketing-consent]');
    var consentYes = restockAlert.querySelector('[data-nj-restock-consent-yes]');
    var consentNo = restockAlert.querySelector('[data-nj-restock-consent-no]');
    var consentStatus = restockAlert.querySelector('[data-nj-restock-consent-status]');
    var whatsappConsentIdentity = null;

    var restockChannels = restockAlert.querySelectorAll(

      'input[name^="nj-restock-channel-"]'

    );



    if (restockCountry) {

      var detectedCountry = restockCountry.dataset.defaultCountry || 'IN';

      var detectedOption = restockCountry.querySelector(

        'option[data-country="' + detectedCountry + '"]'

      );



      restockCountry.value = detectedOption ? detectedOption.value : '+91';

    }



    function selectedRestockChannel() {

      var selected = restockAlert.querySelector(

        'input[name^="nj-restock-channel-"]:checked'

      );



      return selected ? selected.value : 'email';

    }



    function updateRestockFields() {      if (marketingConsent) marketingConsent.hidden = true;
      if (consentStatus) consentStatus.textContent = '';
      if (consentYes) consentYes.disabled = false;
      if (consentNo) consentNo.disabled = false;
      whatsappConsentIdentity = null;

      var isWhatsApp = selectedRestockChannel() === 'whatsapp';



      if (restockPhoneRow) {

        restockPhoneRow.hidden = !isWhatsApp;

      }



      if (restockContactLabel) {

        restockContactLabel.textContent = isWhatsApp

          ? 'WhatsApp number'

          : 'Email address';

      }



      if (restockContact) {

        restockContact.type = isWhatsApp ? 'tel' : 'email';

        restockContact.inputMode = isWhatsApp ? 'numeric' : 'email';

        restockContact.autocomplete = isWhatsApp ? 'tel-national' : 'email';

        restockContact.placeholder = isWhatsApp

          ? 'Enter WhatsApp number'

          : 'Enter your email address';

      }



      if (restockStatus) {

        restockStatus.textContent = '';

      }

    }



    restockChannels.forEach(function(channel) {

      channel.addEventListener('change', updateRestockFields);

    });



    updateRestockFields();

    if (consentYes) {
      consentYes.addEventListener('click', function() {
        if (!whatsappConsentIdentity) return;
        consentYes.disabled = true;
        if (consentNo) consentNo.disabled = true;
        if (consentStatus) consentStatus.textContent = 'Updating your WhatsApp preferenceâ€¦';
        fetch('https://cwinterface.herokuapp.com/marketing/restock/whatsapp-marketing-consent/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(whatsappConsentIdentity)
        }).then(function(response) {
          return response.json().then(function(data) { return { ok: response.ok, data: data }; });
        }).then(function(result) {
          if (!result.ok) throw new Error(result.data.error || 'Unable to update your WhatsApp marketing preference.');
          
          if (consentStatus) consentStatus.textContent = 'Thank you. Your restock alert is active and you are subscribed to WhatsApp updates.';
        }).catch(function() {
          if (consentStatus) consentStatus.textContent = "Your restock alert is active, but we couldn't update your WhatsApp marketing preference right now. Please try again.";
          consentYes.disabled = false;
          if (consentNo) consentNo.disabled = false;
        });
      });
    }

    if (consentNo) {
      consentNo.addEventListener('click', function() {
        
        if (consentYes) consentYes.disabled = true;
        consentNo.disabled = true;
        if (consentStatus) consentStatus.textContent = 'Your restock alert is active. Your existing marketing preference has not been changed.';
      });
    }
    if (restockSubmit) {

      restockSubmit.addEventListener('click', function() {

        var channel = selectedRestockChannel();
        if (marketingConsent) marketingConsent.hidden = true;
        if (consentStatus) consentStatus.textContent = '';
        if (consentYes) consentYes.disabled = false;
        if (consentNo) consentNo.disabled = false;
        whatsappConsentIdentity = null;

        var contact = restockContact ? restockContact.value.trim() : '';

        var hiddenVariant = section.querySelector('input[name="id"]');

        var variantId = variantSelect

          ? variantSelect.value

          : (hiddenVariant ? hiddenVariant.value : '');



        if (!contact || !variantId) {

          restockStatus.textContent =

            'Please select the item and enter your contact details.';

          return;

        }



        var payload = {

          channel: channel,

          shopify_product_id: 'gid://shopify/Product/' + restockAlert.dataset.productId,

          shopify_variant_id: 'gid://shopify/ProductVariant/' + variantId,

          email: '',

          phone: ''

        };



        if (channel === 'email') {

          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact)) {

            restockStatus.textContent = 'Please enter a valid email address.';

            return;

          }



          payload.email = contact.toLowerCase();

        } else {

          var localNumber = contact.replace(/\D/g, '');



          if (!localNumber || !restockCountry || !restockCountry.value) {

            restockStatus.textContent =

              'Please select your country and enter a valid WhatsApp number.';

            return;

          }



          payload.phone = restockCountry.value + localNumber;

        }



        restockSubmit.disabled = true;

        restockStatus.textContent = 'Saving your restock alert…';



        fetch('https://cwinterface.herokuapp.com/marketing/restock/subscribe/', {

          method: 'POST',

          headers: {

            'Content-Type': 'application/json'

          },

          body: JSON.stringify(payload)

        })

          .then(function(response) {

            return response.json().then(function(data) {

              return {

                ok: response.ok,

                data: data

              };

            });

          })

          .then(function(result) {

            if (!result.ok) {

              throw new Error(

                result.data.error || 'Unable to save your restock alert.'

              );

            }



            restockStatus.textContent =

              'Your restock alert has been saved. We will notify you when this item is available.';

            if (channel === 'whatsapp') {
              whatsappConsentIdentity = { shopify_product_id: payload.shopify_product_id, shopify_variant_id: payload.shopify_variant_id || '', phone: payload.phone };
              if (marketingConsent) marketingConsent.hidden = false;
              if (consentStatus) consentStatus.textContent = '';
            }

          })

          .catch(function(error) {

            restockStatus.textContent = error.message;

          })

          .then(function() {

            restockSubmit.disabled = false;

          });

      });

    }

  }



  var sticky = section.querySelector('[data-nj-mobile-sticky]');

  var mainAdd = section.querySelector('[data-nj-main-add]');



  if (!sticky || !mainAdd || !('IntersectionObserver' in window)) return;



  var addVisible = true;



  function updateSticky() {

    var hasPassedMainAdd = mainAdd.getBoundingClientRect().bottom <= 0;

    var shouldShow = hasPassedMainAdd && !addVisible;



    sticky.classList.toggle('is-visible', shouldShow);

    sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');



    var stickyButton = sticky.querySelector('[data-nj-sticky-add]');



    if (stickyButton) {

      stickyButton.tabIndex = shouldShow ? 0 : -1;

    }

  }



  new IntersectionObserver(function(entries) {

    addVisible = entries[0].isIntersecting;

    updateSticky();

  }, {

    threshold: 0.15

  }).observe(mainAdd);

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-product-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var prev = event.target.closest('[data-nj-showcase-prev]');
    var next = event.target.closest('[data-nj-showcase-next]');

    if (!prev && !next) return;

    var section = event.target.closest('[data-nj-product-showcase]');
    if (!section || section.dataset.njShowcaseSlider !== 'true') return;

    var track = section.querySelector('[data-nj-showcase-track]');
    if (!track) return;

    var amount = track.clientWidth * 0.82;
    track.scrollBy({ left: next ? amount : -amount, behavior: 'smooth' });
  });

  document.addEventListener('submit', async function(event) {
    var form = event.target.closest('form[data-nj-showcase-cart-form]');

    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.dataset.submitting === 'true') return;

    var submitButton = form.querySelector('[type="submit"]');
    var productInfo = form.closest('.nj-product-showcase__info');
    var cartDrawer = document.querySelector('cart-drawer');
    var existingError = productInfo && productInfo.querySelector('.nj-product-showcase__form-error');
    var wasDisabled = submitButton ? submitButton.disabled : false;

    form.dataset.submitting = 'true';

    if (existingError) existingError.remove();

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('loading');
      submitButton.setAttribute('aria-busy', 'true');
    }

    try {
      var formData = new FormData(form);
      var sectionHandles = ['cart-drawer', 'cart-icon-bubble'];

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        sectionHandles = cartDrawer
          .getSectionsToRender()
          .map(function(section) {
            return section.section || section.id;
          })
          .filter(Boolean);
      }

      sectionHandles = Array.from(new Set(sectionHandles));

      if (sectionHandles.length) {
        formData.set('sections', sectionHandles.join(','));
        formData.set('sections_url', window.location.pathname);
      }

      if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(submitButton || document.activeElement);
      }

      var rootUrl = window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

      var response = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData,
        credentials: 'same-origin'
      });

      var result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add this product to the cart.');
      }

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(result);
      } else if (cartDrawer && result.sections) {
        var parser = new DOMParser();
        var drawerHtml = result.sections['cart-drawer'];
        var bubbleHtml = result.sections['cart-icon-bubble'];

        if (drawerHtml) {
          var drawerDocument = parser.parseFromString(drawerHtml, 'text/html');
          var incomingDrawer = drawerDocument.querySelector('#CartDrawer .drawer__inner');
          var currentDrawer = cartDrawer.querySelector('#CartDrawer .drawer__inner');

          if (incomingDrawer && currentDrawer) {
            currentDrawer.innerHTML = incomingDrawer.innerHTML;
          }
        }

        if (bubbleHtml) {
          var bubbleDocument = parser.parseFromString(bubbleHtml, 'text/html');
          var incomingBubble = bubbleDocument.querySelector('#cart-icon-bubble');
          var currentBubble = document.querySelector('#cart-icon-bubble');

          if (incomingBubble && currentBubble) {
            currentBubble.innerHTML = incomingBubble.innerHTML;
          }
        }
      }

      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
      }

      window.requestAnimationFrame(function() {
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else if (window.Shopify && window.Shopify.actions && window.Shopify.actions.openCart) {
          window.Shopify.actions.openCart();
        }
      });
    } catch (error) {
      console.error('Product showcase add-to-cart error:', error);

      var message = error && error.message
        ? error.message
        : 'Unable to add this product to the cart.';

      if (productInfo) {
        var errorElement = document.createElement('small');
        errorElement.className = 'nj-product-showcase__form-error';
        errorElement.setAttribute('role', 'alert');
        errorElement.textContent = message;
        productInfo.appendChild(errorElement);
      }
    } finally {
      form.dataset.submitting = 'false';

      if (submitButton) {
        submitButton.disabled = wasDisabled;
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-busy');
      }
    }
  }, true);

  } catch(e) { console.error(e); }
})();
})();
